import { state } from 'react-beep';
import { get } from 'lodash';

export default (role) => {
  const type = get(state, 'profile.user_profile.user_type');
  switch (role) {
    case 'payroll deduction':
      return type === 'naft';
    case 'payroll deduction goBank':
      return type === 'naft';
    case 'point list':
      return type !== 'naft';
    case 'pay as cheque':
      return type !== 'naft';
    case 'hidden logo':
      return type === 'naft';
    case 'discount code':
      return type !== 'naft';
    case 'edit number':
      return type !== 'naft';
    default:
      return false;
  }
};
